<template>
    <fragment>
        <tr>
            <td>
                <short-info :convention="convention" />
            </td>
            <td>
                <panorama-activities-codes
                    :convention="convention"
                    :apenafsByCode="apenafsByCode"
                />
            </td>
            <subjects-body
                :subjects="displayedSubjects"
                :convention="convention"
                :insurers="insurers"
                :annotationOptions="annotationOptions"
            />
        </tr>
        <tr class="child-row" v-for="child in convention.children" :key="child.variantId">
            <td>
                <short-info :convention="child" :isChild="true" />
            </td>
            <td>
                <panorama-activities-codes :convention="child" :apenafsByCode="apenafsByCode" />
            </td>
            <subjects-body
                :subjects="displayedSubjects"
                :convention="child"
                :insurers="insurers"
                :annotationOptions="annotationOptions"
            />
        </tr>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import ShortInfo from "./result-display/ShortInfo.vue";
import SubjectsBody from "./result-display/SubjectsBody.vue";
import PanoramaActivitiesCodes from "./result-display/PanoramaActivitiesCodes.vue";

export default {
    components: {
        Fragment,
        ShortInfo,
        SubjectsBody,
        PanoramaActivitiesCodes,
    },
    props: ["convention", "displayedSubjects", "insurers", "annotationOptions", "apenafsByCode"],
};
</script>

<style lang="sass" scoped>
tr:not(:last-child)
    border-bottom: 1px solid $color-grey

.child-row
    td:first-child
        padding-left: 32px
</style>
